import { Button } from "@chakra-ui/react-v3";
import { RiDownloadLine } from "react-icons/ri";

type CollateDocumentsButtonProps = {
  count: number;
  onClick: () => void;
};

export function CollateDocumentsButton({ count, onClick }: CollateDocumentsButtonProps) {
  if (count === 0) {
    return null;
  }

  return (
    <Button
      position="fixed"
      bottom={25}
      right={60}
      borderRadius="md"
      size="lg"
      onClick={onClick}
      boxShadow="xl"
      zIndex={1000}
      gap={2}
      py="6"
      bg="btn.success.bg"
      color="btn.success.color"
      _hover={{ borderColor: "btn.success.hoverBorder" }}
    >
      <RiDownloadLine size={20} />
      Download documents ({count})
    </Button>
  );
}
